import React from "react";

import { Spinner, Container, Dropdown } from "react-bootstrap";

import Header from "../../Common/Header";
import useCandidateJobInvites from "./useCandidateJobInvites";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  faCircleInfo,
  faDeleteLeft,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AppliedJobSearch from "./AppliedJobSearch";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation } from "swiper";
import {
  EMPLOYMENT_TYPE,
  EXPERIENCE_TYPE,
  INTERVIEW_STAGE_TYPE,
} from "../../Common/JobBoard/constants";
import { CountrySearchDropdown } from "../../../_uiComponents/Search/CountrySearchDropdown";
import { fixImageUrl } from "../../../_helpers/fixImageUrl";
import MainLayout from "../../Common/MainLayout";
import { dateFormatter } from "../../../_helpers/dateFormatter";
export default (props) => {
  const navigate = useNavigate();

  const {
    loading,
    allJobs,
    showSearch,
    searchInputRef,
    searchSkillInputRef,
    jobSearch,
    candidateSelectedEmployment,
    candidateSelectedSkill,
    onSearchInputChange,
    candidateSelectedExperience,
    candidateSelectedCountry,
    skillsTagsAdded,
    candidateSelectedInterviewStage,
    showSkillSearch,
    searchInputValue,
    setLastElement,
    onViewJobDetails,
    onSearch,
    onCandidateJobsFilterChange,
    checkSelectedTag,
    onCandidateFilterUnselectClick,
    onHandleSkillsReset,
    resetEmployment,
    resetExperience,
    resetInterviewStage,
    resetCountryFilter,
    onHandleClearAllFilter,
    onSkillSearch,
    onSearchSkillChange,
  } = useCandidateJobInvites();

  return (
    <MainLayout pageName={"Job Invites"}>

      <Container>

        <div>
          <div className="hiring-process-dashboard kanban-board-main mt-4">
            <ul className="my-4 nav nav-tabs" role="tablist">
              <li className="nav-item">
                <Link type="button" to="/job-board" className="nav-link ">
                  Job Board
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  type="button"
                  to="/all-applied-jobs"
                  className="nav-link "
                >
                  My Jobs
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  type="button"
                  to="/candidate-invited-jobs"
                  className="nav-link active"
                >
                  Invited Jobs
                </Link>
              </li>
            </ul>
          </div>
          <div className="tab-content">
            <div role="tabpanel" className="fade tab-pane active show">
              <div className="row">
                <div className="col-xl-6">
                  <div className="search-box input-group border border-radius-10 bg-white mb-2">
                    <input
                      type="text"
                      className="form-control border-0 bg-transparent"
                      placeholder="Search Jobs"
                      onChange={(e) => onSearchInputChange(e)}
                      ref={searchInputRef}
                      style={{ height: "46px" }}
                    />
                    <div className="input-group-append">
                      {showSearch ? (
                        <button className="btn p-2" type="button" onClick={onSearch}>
                          <FontAwesomeIcon icon={faDeleteLeft} className="ml-2" />
                        </button>
                      ) : (
                        <button className="btn p-2" type="button">
                          <img src="../assets/images/search-icon.png" alt="search" />
                        </button>
                      )}
                    </div>
                  </div>
                  <h3 className="mb-2">
                    Filters
                    {(Array.isArray(candidateSelectedCountry) &&
                      candidateSelectedCountry.length) ||
                      (Array.isArray(candidateSelectedEmployment) &&
                        candidateSelectedEmployment.length) ||
                      (Array.isArray(candidateSelectedExperience) &&
                        candidateSelectedExperience.length) ? (
                      <button
                        className="btn py-1 ml-3 btn-primary"
                        onClick={onHandleClearAllFilter}
                      >
                        Clear All Filter
                      </button>
                    ) : null}
                  </h3>
                  <div className="d-flex flex-wrap align-items-center mb-4 mr-3">
                    <div className="mr-3 my-1">
                      <Dropdown>
                        <Dropdown.Toggle
                          variant=""
                          className="border border-secondary bg-grey d-flex align-items-center"
                        >
                          Employment Type
                          {Array.isArray(candidateSelectedEmployment) &&
                            candidateSelectedEmployment?.length ? (
                            <span
                              className="bg-danger  rounded-circle ml-2 text-center"
                              style={{
                                height: "20px",
                                width: "20px",
                                fontSize: "10px",
                                lineHeight: "20px",
                              }}
                            >
                              {Array.isArray(candidateSelectedEmployment) &&
                                candidateSelectedEmployment?.length}
                            </span>
                          ) : null}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <ul className="px-3">
                            {EMPLOYMENT_TYPE &&
                              Array.isArray(EMPLOYMENT_TYPE) &&
                              EMPLOYMENT_TYPE?.map((item) => (
                                <>
                                  <li
                                    title={
                                      checkSelectedTag(
                                        item?.value,
                                        "employment"
                                      )
                                        ? "select"
                                        : "unselect"
                                    }
                                    className="d-flex py-2 text-nowrap align-items-center font-weight-semi cursor-pointer justify-content-between"
                                  >
                                    <span className="flex-grow-1">
                                      {item?.key}
                                    </span>
                                    {checkSelectedTag(
                                      item?.value,
                                      "employment"
                                    ) ? (
                                      <Dropdown.Item
                                        className="bg-transparent border-0 ml-3
                                         text-danger position-relative w-auto d-inline-block"
                                        style={{ zIndex: 2 }}
                                        onClick={() =>
                                          onCandidateFilterUnselectClick(
                                            item?.value,
                                            "employment"
                                          )
                                        }
                                      >
                                        <FontAwesomeIcon icon={faXmark} />
                                      </Dropdown.Item>
                                    ) : (
                                      <Dropdown.Item
                                        className="bg-primary-light rounded-pill d-inline-block w-auto  ml-3 text-primary border border-primary position-relative h4 font-weight-normal"
                                        style={{ zIndex: 2 }}
                                        onClick={() =>
                                          onCandidateJobsFilterChange(
                                            item?.value,
                                            "employment"
                                          )
                                        }
                                      >
                                        Select
                                      </Dropdown.Item>
                                    )}
                                  </li>
                                </>
                              ))}
                          </ul>
                          <div className="d-flex align-items-center border-top pt-2 px-3 justify-content-end">
                            <Dropdown.Item
                              className="btn btn-dark w-auto py-1"
                              onClick={resetEmployment}
                            >
                              Reset
                            </Dropdown.Item>
                          </div>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div className="mr-3 my-1">
                      <Dropdown>
                        <Dropdown.Toggle
                          variant=""
                          className="d-flex border border-secondary bg-grey align-items-center"
                        >
                          Experience
                          {Array.isArray(candidateSelectedExperience) &&
                            candidateSelectedExperience?.length ? (
                            <span
                              className="bg-danger  rounded-circle ml-2 text-center"
                              style={{
                                height: "20px",
                                width: "20px",
                                fontSize: "10px",
                                lineHeight: "20px",
                              }}
                            >
                              {Array.isArray(candidateSelectedExperience) &&
                                candidateSelectedExperience?.length}
                            </span>
                          ) : null}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <ul className="px-3">
                            {EXPERIENCE_TYPE &&
                              Array.isArray(EXPERIENCE_TYPE) &&
                              EXPERIENCE_TYPE?.map((item) => (
                                <>
                                  <li
                                    title={
                                      checkSelectedTag(
                                        item?.value,
                                        "experience"
                                      )
                                        ? "select"
                                        : "unselect"
                                    }
                                    className="d-flex py-2 text-nowrap align-items-center font-weight-semi cursor-pointer justify-content-between"
                                  >
                                    {item?.key}
                                    {checkSelectedTag(
                                      item?.value,
                                      "experience"
                                    ) ? (
                                      <Dropdown.Item
                                        className="bg-transparent w-auto d-inline-block border-0 ml-3 text-danger position-relative"
                                        style={{ zIndex: 2 }}
                                        onClick={() =>
                                          onCandidateFilterUnselectClick(
                                            item?.value,
                                            "experience"
                                          )
                                        }
                                      >
                                        <FontAwesomeIcon icon={faXmark} />
                                      </Dropdown.Item>
                                    ) : (
                                      <Dropdown.Item
                                        className="bg-primary-light rounded-pill d-inline-block w-auto  ml-3 text-primary border border-primary position-relative h4 font-weight-normal"
                                        style={{ zIndex: 2 }}
                                        onClick={() =>
                                          onCandidateJobsFilterChange(
                                            item?.value,
                                            "experience"
                                          )
                                        }
                                      >
                                        Select
                                      </Dropdown.Item>
                                    )}
                                  </li>
                                </>
                              ))}
                          </ul>
                          <div className="d-flex align-items-center border-top pt-2 px-3 justify-content-end">
                            <Dropdown.Item
                              className="btn btn-dark py-1 w-auto d-inline-block"
                              onClick={resetExperience}
                            >
                              Reset
                            </Dropdown.Item>
                          </div>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div className="mr-3 my-1">
                      <Dropdown>
                        <Dropdown.Toggle
                          variant=""
                          className="d-flex border border-secondary bg-grey align-items-center"
                        >
                          Country
                          {candidateSelectedCountry?.length ? (
                            <span
                              className="bg-danger  rounded-circle ml-2 text-center"
                              style={{
                                height: "20px",
                                width: "20px",
                                fontSize: "10px",
                                lineHeight: "20px",
                              }}
                            >
                              {candidateSelectedCountry?.length}
                            </span>
                          ) : null}
                        </Dropdown.Toggle>
                        <Dropdown.Menu style={{ minWidth: "200px" }}>
                          <div className="p-2">
                            <CountrySearchDropdown
                              searchStyle={{ width: "100%" }}
                              placeholder="Country"
                              onSearchSelect={(e) =>
                                onCandidateJobsFilterChange(e.name, "country")
                              }
                              defaultCountryValue={"Type Country Name..."}
                            />

                            <div className="d-flex d-flex mt-3 align-items-center flex-wrap">
                              {Array.isArray(candidateSelectedCountry) &&
                                candidateSelectedCountry?.map((item) => (
                                  <div className="h4 py-1 text-capitalize border rounded-pill font-weight-normal cursor-pointer bg-primary-light border-primary text-primary px-2 mr-2 text-capitalize d-flex">
                                    {item}
                                    <Dropdown.Item
                                      onClick={() =>
                                        onCandidateFilterUnselectClick(
                                          item,
                                          "country"
                                        )
                                      }
                                      className="bg-transparent border-0 w-auto d-inline-block position-relative"
                                      style={{ zIndex: 2 }}
                                    >
                                      <FontAwesomeIcon icon={faXmark} />
                                    </Dropdown.Item>
                                  </div>
                                ))}
                            </div>

                            <div className="d-flex mt-3 align-items-center border-top pt-2 px-3 justify-content-end">
                              <Dropdown.Item
                                className="btn btn-dark py-1 w-auto d-inline-block"
                                onClick={resetCountryFilter}
                              >
                                Reset
                              </Dropdown.Item>
                            </div>
                          </div>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="d-flex mb-3 align-items-center justify-content-between">
                    <div className="search-box flex-grow-1 input-group border border-radius-10 bg-white">
                      <input
                        type="text"
                        className="form-control border-0 bg-transparent"
                        placeholder="Search Skills"
                        onChange={(e) => onSearchSkillChange(e)}
                        ref={searchSkillInputRef}
                        style={{ height: "46px" }}
                      />
                      <div className="input-group-append">
                        {showSkillSearch ? (
                          <button
                            className="btn p-2"
                            type="button"
                            onClick={onSkillSearch}
                          >
                            <FontAwesomeIcon
                              icon={faDeleteLeft}
                              className="ml-2"
                            />
                          </button>
                        ) : (
                          <button className="btn p-2" type="button">
                            <img
                              src="../assets/images/search-icon.png"
                              alt="search"
                            />
                          </button>
                        )}
                      </div>
                    </div>
                    {Array.isArray(candidateSelectedSkill) &&
                      candidateSelectedSkill &&
                      candidateSelectedSkill.length ? (
                      <button
                        className="btn py-1 ml-3 btn-primary"
                        onClick={onHandleSkillsReset}
                      >
                        Clear All
                      </button>
                    ) : null}
                  </div>

                  {showSkillSearch ? (
                    <Swiper
                      slidesPerView={"auto"}
                      spaceBetween={5}
                      modules={[FreeMode, Navigation]}
                      className="custom-tab-slider"
                      navigation={true}
                      loop={true}
                    >
                      {Array.isArray(skillsTagsAdded) &&
                        skillsTagsAdded &&
                        skillsTagsAdded.length ? (
                        <>
                          {skillsTagsAdded &&
                            Array.isArray(skillsTagsAdded) &&
                            skillsTagsAdded.map((tag, index) => (
                              <SwiperSlide>
                                <div
                                  className={`h4 py-1 border rounded-pill font-weight-normal cursor-pointer ${checkSelectedTag(tag?.skill, "skill")
                                      ? "bg-primary-light border-primary text-primary"
                                      : "text-grey-4 bg-white"
                                    } px-2 mr-2 text-capitalize d-flex`}
                                  key={index}
                                >
                                  <div
                                    onClick={() =>
                                      onCandidateJobsFilterChange(
                                        tag?.skill,
                                        "skill"
                                      )
                                    }
                                    className="d-flex flex-wrap pr-1"
                                  >
                                    {tag?.skill}
                                  </div>
                                  {checkSelectedTag(tag?.skill, "skill") ? (
                                    <button
                                      className="bg-transparent border-0 position-relative"
                                      style={{ zIndex: 2 }}
                                      onClick={() =>
                                        onCandidateFilterUnselectClick(
                                          tag?.skill,
                                          "skill"
                                        )
                                      }
                                    >
                                      <FontAwesomeIcon icon={faXmark} />
                                    </button>
                                  ) : null}
                                </div>
                              </SwiperSlide>
                            ))}
                        </>
                      ) : (
                        <p className="text-danger text-center">
                          "Not Skill Found"
                        </p>
                      )}
                    </Swiper>
                  ) : null}

                  <Swiper
                    slidesPerView={"auto"}
                    spaceBetween={5}
                    modules={[FreeMode, Navigation]}
                    className="custom-tab-slider"
                    navigation={true}
                    loop={true}
                  >
                    {candidateSelectedSkill &&
                      Array.isArray(candidateSelectedSkill) &&
                      candidateSelectedSkill.map((tag, index) => (
                        <SwiperSlide>
                          <div
                            className={`h4 py-1 border rounded-pill font-weight-normal cursor-pointer ${checkSelectedTag(tag, "skill")
                                ? "bg-primary-light border-primary text-primary"
                                : "text-grey-4 bg-white"
                              } px-2 mr-2 text-capitalize d-flex`}
                            key={index}
                          >
                            <div
                              onClick={() =>
                                onCandidateJobsFilterChange(tag, "skill")
                              }
                              className="d-flex flex-wrap pr-1"
                            >
                              {tag}
                            </div>
                            {checkSelectedTag(tag, "skill") ? (
                              <button
                                className="bg-transparent border-0 position-relative"
                                style={{ zIndex: 2 }}
                                onClick={() =>
                                  onCandidateFilterUnselectClick(tag, "skill")
                                }
                              >
                                <FontAwesomeIcon icon={faXmark} />
                              </button>
                            ) : null}
                          </div>
                        </SwiperSlide>
                      ))}
                  </Swiper>
                </div>
              </div>

              {loading ? (
                <div className="d-flex justify-content-center align-items-center">
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : Array.isArray(allJobs) && allJobs && allJobs.length > 0 ? (
                <div>
                  <div className="d-flex align-items-end justify-content-between mb-3">
                    <h2 className="d-inline-block mb-2">
                      {" "}
                      Showing {Array.isArray(allJobs) && allJobs.length} Jobs
                    </h2>
                  </div>

                  <div className="job-listing">
                    <div className="row">
                      {Array.isArray(allJobs) &&
                        allJobs.map((data, index) => (
                          <div
                            className="col-lg-6 mb-4"
                            key={index}
                            ref={setLastElement}
                          >
                            <div
                              className="d-flex flex-column h-100 p-4 bg-white border position-relative border-radius-10"
                              key={data?.job_details?.id}
                            >
                              <div className="upper mb-3">
                                <div className="d-flex mb-3 align-items-start justify-content-between">
                                  <div className="d-flex">
                                    <img
                                      src={
                                        data?.job_posting_details
                                          ?.posted_by_details?.profile_image
                                          ? fixImageUrl(
                                            data?.job_posting_details
                                              ?.posted_by_details
                                              ?.profile_image
                                          )
                                          : "/assets/images/building-placeholder.png"
                                      }
                                      alt="company logo"
                                      className="border-radius-10 mr-3"
                                      style={{
                                        maxWidth: "48px",
                                        maxHeight: "48px",
                                      }}
                                    />
                                    <div className="job-info">
                                      <h3 className="font-weight-medium mb-1 cursor-pointer text-capitalize">
                                        {data?.job_posting_details &&
                                          data.job_posting_details?.title}
                                      </h3>
                                      <p className="mb-1 fs-14 text-capitalize">
                                        <span className="text-muted">
                                          {data?.job_posting_details &&
                                            data.job_posting_details
                                              ?.posted_by_details &&
                                            data.job_posting_details
                                              .posted_by_details
                                              ?.company_details &&
                                            data.job_posting_details
                                              .posted_by_details.company_details
                                              ?.name}
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <p className="skills mt-2">
                                  {Array.isArray(
                                    data?.job_posting_details &&
                                    data.job_posting_details?.skill_names
                                  ) &&
                                    data?.job_posting_details &&
                                    data.job_posting_details?.skill_names &&
                                    data.job_posting_details.skill_names.length >
                                    1 ? (
                                    <>
                                      {Array.isArray(
                                        data?.job_posting_details &&
                                        data.job_posting_details
                                          ?.skill_names &&
                                        data?.job_posting_details &&
                                        data.job_posting_details?.skill_names
                                      ) &&
                                        data?.job_posting_details &&
                                        data.job_posting_details?.skill_names &&
                                        data?.job_posting_details &&
                                        data.job_posting_details?.skill_names
                                          .slice(0, 6)
                                          .map((skill) => (
                                            <span className="skill bg-grey-4 rounded-lg px-2 mr-2 text-capitalize mb-2">
                                              {skill}
                                            </span>
                                          ))}
                                      <p className="text-muted d-inline-block">
                                        {Array.isArray(
                                          data?.job_posting_details &&
                                          data.job_posting_details
                                            ?.skill_names &&
                                          data.job_posting_details.skill_names
                                        ) &&
                                          data?.job_posting_details &&
                                          data.job_posting_details?.skill_names &&
                                          data.job_posting_details.skill_names
                                            .length > 6
                                          ? "..."
                                          : null}
                                      </p>
                                    </>
                                  ) : (
                                    <>Skills Not Specified</>
                                  )}
                                </p>

                                <div className="d-flex align-items-center fs-smallest text-capitalize mb-3">
                                  <p className="mb-0 bg-grey-4 rounded-pill border  py-1 px-3 mr-2">
                                    {data?.job_posting_details
                                      ?.employment_type ? (
                                      <>
                                        {data?.job_posting_details &&
                                          data.job_posting_details
                                            ?.employment_type &&
                                          data.job_posting_details.employment_type.replace(
                                            /_/g,
                                            " "
                                          )}
                                      </>
                                    ) : (
                                      null
                                    )}
                                  </p>

                                  <p className="mb-0 bg-grey-4 rounded-pill border  py-1 px-3 mr-2">
                                    {data?.job_posting_details?.experience ? (
                                      <>
                                        {data?.job_posting_details &&
                                          data.job_posting_details
                                            ?.experience &&
                                          data.job_posting_details.experience.replace(
                                            /_/g,
                                            " "
                                          )}
                                      </>
                                    ) : (
                                      null
                                    )}
                                  </p>

                                  {data?.job_posting_details?.is_remote ? (
                                    <p className="mb-0 bg-grey-4 rounded-pill border  py-1 px-3 mr-2">
                                      Remote
                                    </p>
                                  ) : null}
                                </div>
                              </div>
                              <div className="border-top pt-3 d-flex justify-content-between align-items-center mt-auto">
                                <p className="mb-0 mr-2 text-muted-4 text-capitalize">
                                  {data?.invited_by_details?.created ? (
                                    <p className="text-grey-4 mb-0">
                                      {" "}
                                      Invited on{" "}
                                      {dateFormatter(data?.invited_by_details?.created)}
                                    </p>
                                  ) : (
                                    "Not Disclosed"
                                  )}
                                </p>
                                <button
                                  className="btn text-primary p-0 font-weight-semi"
                                  onClick={() => {
                                    navigate(
                                      `/view-job-detail/${data?.job_posting_details?.id}`
                                    );
                                  }}
                                >
                                  View Job
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className="d-flex align-items-center
                justify-content-center flex-column py-4"
                >
                  <img src="/assets/images/empty-state.svg" alt="empty" />
                  <h4 className="font-weight-bold mb-1 mt-2">
                    You have not been invited to any job!
                  </h4>
                  <p className="mb-4 fs-smallest">Start Applying to Jobs</p>
                  <Link
                    to={"/job-board"}
                    className="px-4 border border-primary shadow
                text-primary py-1 rounded-lg font-weight-semi"
                  >
                    See Jobs
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </Container>
    </MainLayout>
  );
};
